import { ElementType, FC, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader,
  Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography, } from '@material-ui/core';
import { CustomerGetResponse, CustomerUser } from 'src/interfaces/user/customer';
import { LocalPhone } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import RedeemIcon from '@material-ui/icons/Redeem';
import LinkIcon from '@material-ui/icons/Link';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import viewContext from 'src/viewContext';
import { rewardApi } from 'src/api/rewardTransaction';
import { useAuth } from 'src/hooks/use-auth';
import { Roles } from 'src/enums/role-based-auth-guard';
import { RewardTransactionRequest } from 'src/interfaces/rewardTransaction/rewardTransaction';
import { AddCustomerProfile } from '../dialogs/addCustomerProfile';

interface CustomerProfileProps {
  customerDetail: CustomerGetResponse;
  addEditCustomerProfile?: (data: CustomerUser, isAdd: boolean) => Promise<boolean>;
  enableRaiseRequest: boolean;
}

export const CustomerProfileCard: FC<CustomerProfileProps> = (props) => {
  const { customerDetail, addEditCustomerProfile,
    enableRaiseRequest } = props;
  const { mobileView } = useContext(viewContext);
  const [openAddCustomerProfileDialog, setOpenAddCustomerProfileDialog] = useState(false);
  const [rewardValue, setRewardValue] = useState<number>(0);
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [number, setNumber] = useState<number>(rewardValue);
  const [description, setDescription] = useState('');
  const [isNumberValid, setIsNumberValid] = useState<boolean>(true);

  const getRewardPoints = async () => {
    const result = await rewardApi.getUserRewardBalance(customerDetail?.username);
    setRewardValue(result);
    setNumber(result);
  };

  const handleEncash = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    const encashDetails: RewardTransactionRequest = {
      userName: customerDetail?.username,
      id: 'Encashment',
      idType: 'Encashment',
      description,
      points: (number * -1),
    };
    rewardApi.addReward(encashDetails).then((result) => {
      console.log(result);
      setOpen(false);
      getRewardPoints();
    });
  };
  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value);
    if (newValue > 0 && newValue <= rewardValue) {
      setNumber(newValue);
      setIsNumberValid(true);
    } else if (newValue < 0 || newValue > rewardValue) {
      setIsNumberValid(false);
    }
  };

  const cardsDetails = (text: string, value: number | string, Icon: ElementType) => (
    <Grid
      item
      md={6}
      xs={12}
      sm={6}
    >
      <Card
        sx={{
          p: 0,
        }}
        variant="outlined"
      >
        <CardContent
          sx={{
            p: 1
          }}
        >
          <Box
            sx={{
              mt: 0,
              pb: 2,
              pt: 0,
              ml: 1,
              display: 'inline-block',
              height: '50px',
              width: '50px',
              backgroundColor: 'primary.main',
              color: 'white',
              borderRadius: '25px',
            }}
          >
            {Icon && (
              <Box
                sx={{
                  display: 'flex',
                  mr: 2
                }}
              >
                <Avatar
                  sx={{
                    backgroundColor: 'primary.main',
                    height: 56,
                    width: 56
                  }}
                >
                  <Icon sx={{ color: 'primary.contrastText' }} />
                </Avatar>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              ml: 2,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-block'
            }}
          >
            <Typography
              variant="button"
              color="gray"
              sx={{ mt: 1, display: 'block' }}
            >
              {text}
            </Typography>
            <Typography
              variant="button"
              sx={{ display: 'block' }}
            >
              {value}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );

  useEffect(() => {
    if (customerDetail?.username) {
      getRewardPoints();
    }
  }, [customerDetail?.username]);

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          mt: 1
        }}
      >
        <CardHeader
          title="Basic Details"
          // sx={{
          //   pb: enableRaiseRequest ? 2 : 0,
          //   pt: 1
          // }}
          action={!enableRaiseRequest && (
            <>
              <IconButton
                sx={{ p: 0 }}
                aria-label="edit"
                onClick={() => setOpenAddCustomerProfileDialog(true)}
              >
                <EditIcon
                  color="primary"
                />
              </IconButton>
            </>
          )}
        />
        <CardContent
          sx={{
            display: 'flex',
            p: 2,
          }}
        >
          <Grid
            container
          >
            <Grid
              item
              display="contents"
              xs={12}
              md={5}
              sm={12}
            >
              {!mobileView && (
              <Box
                sx={{
                  display: 'inline-block',
                  height: '100px',
                  width: '100px',
                  backgroundColor: 'primary.main',
                  color: 'white',
                  borderRadius: '50px',
                  alignContent: 'center',
                  justifyContent: 'center',
                  mb: 1
                }}
              >
                <Typography
                  sx={{
                    textAlign: 'center',
                    p: '16px',
                    fontSize: '45px',
                    fontWeight: '700',
                  }}
                >
                  {`${(customerDetail?.firstName?.slice(0, 1))?.toUpperCase()}${(customerDetail?.lastName?.slice(0, 1))?.toUpperCase()}`}
                </Typography>
              </Box>
              )}
              <Box
                sx={{
                  flex: 1,
                  ml: mobileView ? 0 : 2,
                  display: 'inline-block'
                }}
              >
                <Typography
                  variant="h4"
                  color="primary"
                  sx={{ mb: 1 }}
                >
                  {customerDetail?.firstName}
                  &nbsp;
                  {customerDetail?.lastName}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ mb: 1 }}
                >
                  <LocalPhone
                    color="primary"
                    sx={{ verticalAlign: 'top', mr: 1 }}
                  />
                  {customerDetail?.mobileNumber}
                  {customerDetail?.altMobileNumber ? `, ${customerDetail?.altMobileNumber}` : ''}
                </Typography>
                { customerDetail?.email && (
                <Typography
                  variant="body2"
                  sx={{ mb: 1 }}
                >
                  <EmailIcon
                    color="primary"
                    sx={{ verticalAlign: 'top', mr: 1 }}
                  />
                  {customerDetail?.email}
                </Typography>
                )}
                {customerDetail?.pincode && (
                <Typography
                  variant="body2"
                  sx={{ mb: 1, display: 'flex' }}
                >
                  <LocationOnIcon
                    color="primary"
                    sx={{ verticalAlign: 'top', mr: 1 }}
                  />
                    {customerDetail?.pincode}
                </Typography>
                )}
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
            >
              <Grid
                container
                spacing={2}
              >
                {(user?.scope === Roles.DEALER) ? null : cardsDetails('REWARDS POINTS', rewardValue, RedeemIcon)}
                {(user?.scope === Roles.DEALER) ? null : cardsDetails('REFERAL CODE', customerDetail?.referralCode, LinkIcon)}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        {user?.scope === Roles.WEB_ADMIN && (
          <CardActions sx={{
            pb: 2,
            pt: 0,
            justifyContent: 'flex-end',
          }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={handleEncash}
              disabled={rewardValue === 0}
            >
              Encash Reward Points
            </Button>

          </CardActions>
        )}

      </Card>
      <AddCustomerProfile
        open={openAddCustomerProfileDialog}
        onClose={() => setOpenAddCustomerProfileDialog(false)}
        mobileNumber={customerDetail?.mobileNumber?.slice(3)}
        addEditCustomerProfile={addEditCustomerProfile}
        customerDetails={customerDetail}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            maxWidth: 500,
            width: '100%'
          }
        }}
      >
        <DialogTitle>Add Encashment</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              mt: 1,
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              label="Amount"
              type="number"
              variant="outlined"
              value={number}
              onChange={handleNumberChange}
              fullWidth
              error={!isNumberValid}
              helperText={!isNumberValid ? 'Number must be less than or equal to reward points.' : ''}
            />
            <TextField
              label="Description"
              variant="outlined"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

CustomerProfileCard.propTypes = {
  // @ts-ignore
  customerDetail: PropTypes.object,
  addEditCustomerProfile: PropTypes.func,
  enableRaiseRequest: PropTypes.bool
};
